// import * as types from './actionsTypes'

//key for localStorage
export const KEY_FCM_TOKEN = 'device_token';
// POS API 推播參數 action  */
export const ACTION_USE_COUPON = "UseCoupon";                           //使用優惠券
export const ACTION_SEND_COUPON = "SendCoupon";                         //發送優惠券 (收到優惠券)
export const ACTION_SEND_REWARD = "SendRewardPoint";                    //發送紅利點數
export const ACTION_FINISH_ORDER = "FinishOrder";                       //完成結帳
export const ACTION_FEEDBACK_LIST = "FeedBackList";                     //回覆意見反映
export const ACTION_GO_FEEDBACK = "GoFeedBack";                         //開啓意見反映詳細頁
export const ACTION_GIFT_COUPON = "GiftCoupon";                         //轉贈優惠卷
export const ACTION_GO_OIN_CARD = "GoOinCard";                          //到禮物盒-活動卡
export const ACTION_GO_REGISTER_GIFT = "RegisterGift";                  //到禮物盒-活動卡(註冊禮)
export const ACTION_GO_COUPON = "GoCoupon";                             //到禮物盒-優惠卷
export const ACTION_ONLINE_ORDER = "OnlineOrder";                       //到點餐
export const ACTION_GO_BOOKING_RECORD = "GoToBooking";                  //前往訂位預約頁面
export const ACTION_BOOKING_ADD = "BookingAdd";                         //前往訂位預約頁面
export const ACTION_BOOKING_CANCEL = "BookingCancel";                   //前往取消訂位預約頁面
export const ACTION_AMOUNT_EXCHANGE_COUPON = "AmountExchangeCoupon";    //金額兌換
export const ACTION_LOYALTY_CARD_EXCHANGE = "LoyaltyCardExchange";      //集點卡兌換
export const ACTION_GO_LOYALTY_CARD = "GoLoyaltyCard";                  //到禮物盒-集點卡
export const ACTION_GO_ANNOUNCEMENT = "GoAnnouncement";                 //到店家公告
export const ACTION_GO_RESERVATION = "Reservation";                     //到預訂相關
export const ACTION_GO_Reward_Point = "GoRewardPoint";                  //到禮物盒-紅利點數
export const ACTION_GO_Gift_Pack_Detail = "GoGiftPackDetail";           //到禮物盒-禮包明細（目前放置優惠券裡）
export const ACTION_GO_COUPON_RECORD = "GoCouponRecord";                //到禮物盒-票券紀錄

// 集點卡兌換方式  */
export const FREE_CONVERT = 1;               //免費兌換
export const PURCHASE_CONVERT = 2;           //加價兌換

// 轉址api用，點擊記錄的種類(type) */
export const REDIRECT_TYPE_REDIRECT = 1;              //導向某個頁面
export const REDIRECT_TYPE_INVITE_CODE = 2;           //點擊邀請碼

// 轉址api用，動作種類(action) */
export const REDIRECT_ACTION_ORDER = "order";         //到禮物盒-集點卡

export const changePosMenu = "changePosMenu"; //換菜單
export const triggerCloseBtn = "triggerCloseBtn"; //觸發關閉


//新搜尋頁用常數
//每個分頁當前顯示的內容的種類常數
export const TAB_ID_COUPON = 0;         //搶券
export const TAB_ID_MARKET = 1;         //商圈
export const TAB_ID_ACTIVITY = 2;       //主題活動
export const TAB_ID_TAKEOUT = 3;        //外帶外送
export const TAB_ID_BOOKING = 4;        //訂候位
export const TAB_ID_STORE = 5;          //店家

//商店的延伸搜尋常數
export const STORE_BOOKING = 1;         //可訂位
export const STORE_TAKEOUT = 2;         //可外帶

//商圈資訊頁，網頁連結種類 常數
export const SITE_TYPE_FB = 1;          //FB
export const SITE_TYPE_LINE = 2;        //Line
export const SITE_TYPE_IG = 3;          //IG
export const SITE_TYPE_YOUTUBE = 4;     //YT
export const SITE_TYPE_TWITTER = 5;     //Twitter
export const SITE_TYPE_WEBSITE = 6;     //官網   //
export const SITE_TYPE_UBEREATS = 7;   //
export const SITE_TYPE_FOODPANDA = 8;   //
export const SITE_TYPE_TIKTOK = 9;

/** 社群網站圖片路徑 */
export const remarkIconPath = [
    require("@/assets/images/marketplace_FB.svg"),
    require("@/assets/images/marketplace_LINE.svg"),
    require("@/assets/images/marketplace_IG.svg"),
    require("@/assets/images/marketplace_YT.svg"),
    require("@/assets/images/marketplace_Twitter.svg"),
    require("@/assets/images/marketplace_web.svg"),
    require("@/assets/images/marketplace_UberEats.svg"),
    require("@/assets/images/marketplace_Foodpanda.svg"),
    require("@/assets/images/marketplace_TikTok.svg"),
];//社群網站圖片路徑

/** 社群網站圖片路徑（白底黑線扁平式） */
export const remarkIconFlatPath = [
    require("@/assets/images/store_FB.svg"),
    require("@/assets/images/store_LINE.svg"),
    require("@/assets/images/store_IG.svg"),
    require("@/assets/images/store_YT.svg"),
    require("@/assets/images/store_Twitter.svg"),
    require("@/assets/images/store_web.svg"),
    require("@/assets/images/store_UberEats.svg"),
    require("@/assets/images/store_Foodpanda.svg"),
    require("@/assets/images/store_TikTok.svg"),
];

/** 社群網站圖片路徑（白底棕線扁平式） */
export const remarkIconFlatBrownPath = [
    require("@/assets/images/store_FB_brown.svg"),
    require("@/assets/images/store_LINE_brown.svg"),
    require("@/assets/images/store_IG_brown.svg"),
    require("@/assets/images/store_YT_brown.svg"),
    require("@/assets/images/store_Twitter_brown.svg"),
    require("@/assets/images/store_web_brown.svg"),
    require("@/assets/images/store_UberEats_brown.svg"),
    require("@/assets/images/store_Foodpanda_brown.svg"),
    require("@/assets/images/store_TikTok_brown.svg"),
];

//商圈用，主辦方類型 0:其他 1:串門子 2:商圈 3:夜市 4:市集 5:店家
export const ShopAreaType = {
    Other: 0,               //其他
    Oin: 1,                 //串門子
    ShoppingArea: 2,        //商圈
    NightMarket: 3,         //夜市
    Market: 4,              //市集
    Store: 5,               //店家
};
//商圈用，商圈類型
export const MerchantType = {
    Store: 1,                        //店家
    Vendor: 2,                       //攤販
    ShoppingAreaMerchantList: 3,     //商圈下的商家(店家或攤販)
    ShoppingArea: 4,                 //商圈
    Oin: 5,                          //oin
    App: 6,                          //app
    Brand: 7,                        //brand
    ShoppingAreaActivity: 8,         //商圈活動
};

export const QRCodeUsedType = {
    SendCoupon:         "SendCoupon",        //送優惠券
    GetInfo:            "GetInfo",           //取得資訊
    SendLoyaltyCard:    "SendLoyaltyCard",   //送集點卡
    TableOrder:         "TableOrder",        //桌邊點餐(每筆都是獨立訂單)
    TableOrderAddItem:  "TableOrderAddItem", //桌邊點餐添加項目(根據orderId)
    SendRewardPoint:    "SendRewardPoint",   //送紅利點數
    SendGiftPack:       "SendGiftPack",      //送禮包
};

//key for sessionStorage


//event for session
export const EVENT_ = 'device_token';

//key for session

//key for order
export const RADIO_TAKE = Object.freeze({takeout: 1, delivery: 2});
export const DISCOUNT_LIMIT = Object.freeze({limitPrice: 1, limitPercentage: 2});

//票券類型
export const TicketType = {
    Coupon: {               //優惠券
        id: 1,
        name: "優惠券",
        unitName: "票券",
        unit: "張",
        value: 'coupon',
    },
    LoyaltyCard: {          //集點卡
        id: 2,
        name: "集點卡",
        unitName: "點數",
        unit: "點",
        value: 'loyaltyCard',
    },
    Card: {                 //會員卡
        id: 3,
        name: "會員卡",
        unitName: "張數",
        unit: "張",
        value: 'card',
    },
    RewardPoint: {          //紅利點數
        id: 4,
        name: "紅利點數",
        unitName: "點數",
        unit: "點",
        value: 'rewardPoint',
    },
    GiftPack: {             //禮包
        id: 5,
        name: "禮包",
        unitName: "禮包",
        unit: "包",
        value: 'giftPack',
    },
};

export const StorageNameType = {
    TableOrderDataToken:     "TableOrderDataToken",    //桌邊點餐
};

export const OrderSettingType = {//僅用來判斷是抓哪種類型設定之類的，跟order_sn沒掛鉤
    Pos:        1,   //POS結帳
    Amount:     2,   //金額結帳
    Delivery:   3,   //外送
    Takeout:    4,   //外帶
    Table:      5,   //桌邊服務
    Reserve:    6,   //預訂
};

export const SpinnerWheelType = {
    ALL: {LABEL_ZH: "全部", VALUE: 0},
    HOMEPAGE: {LABEL_ZH: "享樂遊首頁", VALUE: 1},
    QUESTIONNAIRE: {LABEL_ZH: "問卷", VALUE: 2},
    CHECKOUT: {LABEL_ZH: "結帳", VALUE: 3},
    THEME_ACTIVITIES: {LABEL_ZH: "主題活動", VALUE: 4},
    SHOPPING_AREA: {LABEL_ZH: "主辦活動頁", VALUE: 5},
};

export const TopicType = {
    TITLE: "",
    TRUE_OR_FALSE: "1",
    RADIO: "2",
    STAR: "3",
    SELECT: "4",
    CUSTOM: "5",
    MULTI_SELECT: "6",
    NUMBER: "10",
    DATE: "11",
    ADDRESS: "12",
    VIDEO: "13",
    IMAGE: "14",
    LINE_SCALE: "15",
    NONE: "16"
};

export const OinPayName = "享樂遊錢包";

export const LinePayOnlineApi = {
    Request: "LinePayOnlineApiRequest",
    Check: "LinePayOnlineApiCheck"
}

export const PayType = {
    newebPay: {
        id: 1,
        name: "藍新",
    },
    LinePayOffline: {
        id: 2,
        name: "LINE Pay",
    },
    LinePayOnline: {
        id: 3,
        name: "LINE Pay",
    },
};

export const PosPaymentMethodType = {
    Cash: 0,
    Card: 1,
    Other: 2,
    NewebPay: 3,
    VendingMachine: 4,
    LinePay: 5,
};

export const OpenScanType = {
    MainStoreWeb: 'MainStoreWeb',
    WebStoreCoupon: 'WebStoreCoupon',
};